<template>
  <div v-if="isLoading">
    <va-loading size="lg" color="#3E4095" center></va-loading>
  </div>
  <div v-else class="detail-course-container">
    <!-- {{detailCourse}} -->
    <template v-if="detailCourse">
      <div v-if="nowVideo" class="video-container">
        <VideoPlayer :video="nowVideo" :key="nowVideo._id" />
      </div>
      <div class="header">
        <div class="">
          <!-- <h3>{{detailCourse.name}} {{nowVideo.name ? `&mdash; ${nowVideo.name}` : ''}}</h3> -->
          <h3 class="text-heading">{{ detailCourse.name }}</h3>
          <div class="subheading">
            <template v-if="detailCourse.category">
              <va-lozenge size="lg" :uppercase="false" type="success">{{
                detailCourse.category.name
              }}</va-lozenge>
              &bull;
            </template>
            <h5>{{ parseDuration(detailCourse.totalDuration) }}</h5>
            &bull;
            <h5>
              {{
                moment(detailCourse.createdAt)
                  .locale("id")
                  .format("DD MMMM YYYY")
              }}
            </h5>
          </div>
        </div>
        <div
          v-if="detailCourse.totalStudents > 0 && detailCourse.countReviews > 0"
          class="rating mt-4 md-mt-0"
        >
          <star-rating
            :rating="detailCourse.averageRating"
            :star-size="32"
            :show-rating="false"
            :rounded-corners="true"
            read-only
          />
          <p>
            ({{ detailCourse.countReviews }} Ulasan)
            {{ detailCourse.totalStudents }} Murid
          </p>
        </div>
      </div>
      <hr class="th-border" />
      <section>
        <va-row :gutter="28">
          <va-column :xs="12" :sm="12" :md="8">
            <div class="mentor-profile">
              <img
                width="60"
                style="border-radius: 50px;"
                :src="
                  detailCourse.vendor.profilePicture
                    ? `${backendUrl}${detailCourse.vendor.profilePictureSmall}`
                    : `https://ui-avatars.com/api/?background=3ABAF4&rounded=true&bold=true&color=fff&length=1&size=128&name=${detailCourse.vendor.firstName}`
                "
                alt=""
              />
              <div>
                <p class="th-text-primary th-font-weight-bold">
                  {{ detailCourse.vendor.firstName }}
                  {{ detailCourse.vendor.lastName }}
                </p>
                <p class="th-font-gray-3 th-font-weight-light">Instruktur</p>
              </div>
            </div>
            <div class="course-menu">
              <menu-button
                :menus="menus"
                :menuActive="menuActive"
                @menu-change="menuChange"
              />
              <!-- <template v-for="menu in menus">
                <va-button :key="menu.key" @click.prevent="menuChange(menu.key)" :type="menu.key === menuActive ? 'primary' : 'subtle'">{{menu.name}}</va-button>
              </template> -->
            </div>
            <template v-if="menuActive === 1">
              <section class="description">
                <div
                  v-html="detailCourse.description"
                  class="th-text-paragraph"
                ></div>
              </section>
              <div class="section">
                <div
                  v-for="section in detailCourse.sections"
                  :key="section._id"
                  class="th-card section-container"
                >
                  <Sylabus :title="section.name">
                    <slot>
                      <template v-for="lesson in section.lessons">
                        <ListLesson
                          :lesson="lesson"
                          :key="lesson._id"
                          @play-video="PlayableVideo"
                        />
                      </template>
                    </slot>
                  </Sylabus>
                </div>
              </div>
            </template>
            <template v-if="menuActive === 2">
              <div v-if="detailCourse.reviewsUser.length">
                <ReviewStudent
                  v-for="item in detailCourse.reviewsUser"
                  :review="item"
                  :key="item._id"
                />
              </div>
              <div v-else class="text-center mt-10">Belum ada ulasan</div>
            </template>
          </va-column>
          <va-column :xs="12" :sm="12" :md="4">
            <va-affix :offset="20">
              <div class="th-card price-container">
                <div
                  v-if="
                    detailCourse.type === 'premium' &&
                    detailCourse.discountedCourse
                  "
                  class="flex items-center justify-start mb-4"
                >
                  <div class="line-through text-md opacity-30">
                    {{ priceFormat(detailCourse.price) }}
                  </div>
                  <va-lozenge class="ml-1" :uppercase="true" type="danger"
                    >{{ detailCourse.discountedCourse.percentage }}%</va-lozenge
                  >
                </div>
                <h2>
                  {{
                    detailCourse.type === "free"
                      ? "Gratis"
                      : detailCourse.discountedCourse
                      ? priceFormat(detailCourse.discountedCourse.price)
                      : priceFormat(detailCourse.price)
                  }}
                </h2>
                <div class="group-flex">
                  <p class="th-font-weight-bold">Kelas ini termasuk:</p>
                  <!-- <div class="list-icon">
                    <VideoDownloadIcon />Seluruh Video dapat diunduh
                  </div> -->
                  <div class="list-icon"><VideoHDIcon />Kualitas Video HD</div>
                  <div class="list-icon">
                    <RefreshIcon />Bebas akses seumur hidup
                  </div>
                </div>
                <div v-if="detailCourse.type === 'premium'" class="group-flex">
                  <va-button
                    v-if="!isExistMyCourse"
                    @click.prevent="addToCart"
                    type="primary"
                    block
                    >{{
                      isCarted ? "Ke Keranjang" : "Tambah ke Keranjang"
                    }}</va-button
                  >
                  <va-button
                    :loading="loadingEnroll"
                    @click.prevent="enrollCourse"
                    type="subtle"
                    block
                    >{{
                      sessionId === null
                        ? "Masuk untuk Belajar"
                        : isExistMyCourse
                        ? "Lanjutkan Belajar"
                        : "Beli Sekarang"
                    }}</va-button
                  >
                </div>
                <div
                  v-else-if="detailCourse.type === 'free'"
                  class="group-flex"
                >
                  <va-button
                    :loading="loadingEnroll"
                    @click.prevent="enrollCourse"
                    type="subtle"
                    block
                    >{{
                      sessionId === null
                        ? "Masuk untuk Belajar"
                        : isExistMyCourse
                        ? "Lanjutkan Belajar"
                        : "Ikuti Sekarang"
                    }}</va-button
                  >
                </div>
              </div>
            </va-affix>
          </va-column>
        </va-row>
      </section>
      <template v-if="otherCourse.length">
        <hr class="th-border" />
        <section>
          <h3>
            Course lain dari
            <span class="th-text-primary"
              >{{ detailCourse.vendor.firstName }}
              {{ detailCourse.vendor.lastName }}</span
            >
          </h3>
          <CarouselCourse
            :cardType="1"
            :courses="otherCourse"
            :settings="course1Settings"
          />
        </section>
      </template>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import StarRating from 'vue-star-rating'
import priceFormat from '@/helpers/thousandPrice'
import parseDuration from '@/helpers/videoDuration'
const VideoPlayer = () => import('@/components/Shared/VideoPlayer')
const CarouselCourse = () => import('@/components/Shared/CardCourse/TemplateCarousel')
const Sylabus = () => import('@/components/App/Dropdown/FilterSearch')
const ListLesson = () => import('@/components/Shared/ListLesson/1')
const ReviewStudent = () => import('@/components/Shared/ReviewStudent')
const MenuButton = () => import('@/components/App/Menus/Button')
// const VideoDownloadIcon = () => import('@/components/Icon/VideoDownload')
const VideoHDIcon = () => import('@/components/Icon/VideoHD')
const RefreshIcon = () => import('@/components/Icon/Refresh')

const menus = [
  {
    key: 1,
    name: 'Tentang',
  },
  {
    key: 2,
    name: 'Ulasan',
  },
]
const course1Settings = {
  arrow: false,
  focusOnSelect: false,
  slidesToShow: 1,
  slideToScroll: 1,
  variableWidth: true,
  infinite: false,
}

const courseSection = [
  {
    name: 'Gambaran Course',
    totalLesson: 1,
    lessons: [
      {
        name: 'Trailer',
        duration: '1m 15s',
        isLock: false,
      },
    ],
  },
  {
    name: 'Memulai Kajian Kitab Tadzkiatun Nafs',
    totalLesson: 4,
    lessons: [
      {
        name: 'Perkenalan',
        duration: '3m 45s',
        isLock: false,
      },
      {
        name: 'Menjelaskan Tentang Kitab Tadzkiatun Nafs (PART 1)',
        duration: '50m 27s',
        isLock: true,
      },
      {
        name: 'Menjelaskan Tentang Kitab Tadzkiatun Nafs (PART 2)',
        duration: null,
        isLock: true,
      },
    ],
  },
]
export default {
  components: {
    VideoPlayer,
    StarRating,
    CarouselCourse,
    Sylabus,
    ListLesson,
    ReviewStudent,
    MenuButton,
    // VideoDownloadIcon,
    VideoHDIcon,
    RefreshIcon,
  },
  data() {
    return {
      backendUrl: process.env.VUE_APP_BACKEND_URL,
      menus,
      priceFormat,
      course1Settings,
      courseSection,
      detailCourse: null,
      menuActive: 1,
      otherCourse: [],
      nowVideo: null,
      isExistMyCourse: false,
      loadingEnroll: false,
      isCarted: false,
    }
  },
  methods: {
    moment,
    parseDuration,
    addToCart() {
      if (this.isCarted) {
        this.$router.push({ name: 'Keranjang' })
      } else {
        const carts = {
          key: this.detailCourse._id,
          imgSrc: this.detailCourse.thumbnailSmall ? this.backendUrl + this.detailCourse.thumbnailSmall : null,
          title: this.detailCourse.name,
          by: `${this.detailCourse.vendor.firstName} ${this.detailCourse.vendor.lastName}`,
          price: this.detailCourse.discountedCourse ? this.detailCourse.discountedCourse.price : this.detailCourse.price,
          isSelected: true,
        }
        this.$store.commit('cart/ADD_CART_ITEM', carts)
        this.isCarted = true
      }
    },
    async enrollCourse() {
      if (this.sessionId) {
        if (this.isExistMyCourse) {
          this.$router.push({ name: 'Detail Course Saya', params: { id: this.detailCourse._id } })
        } else {
          if (this.detailCourse.type === 'free') {
            this.loadingEnroll = true
            this.$store.dispatch('course/POST_JOIN_COURSE', { id: this.detailCourse._id })
            this.loadingEnroll = false
            this.notification.success({
              title: 'Berhasil Mengikuti Course',
              message: `Alhamdulillah, anda dapat langsung mengikuti kelas ${this.detailCourse.name}.`,
              duration: 5000,
            })
            this.$router.push({ name: 'Course Saya' })
          } else if (this.detailCourse.type === 'premium') {
            const url = await this.$store.dispatch('transaction/BUY_COURSE', { dataCourse: [this.detailCourse._id] })
            // this.notification.warning({
            //   title: 'Berhasi',
            //   message: 'Layanan Fitur Pembayaran saat ini belum tersedia',
            //   duration: 5000,
            // })
            // console.log(url)
            window.open(url)
          }
        }
      } else {
        this.$router.push({ name: 'Masuk', query: { redirect: this.$route.path } })
      }
    },
    PlayableVideo(payload = { first: false, selectedLesson: [] }) {
      let lesson = {
        poster: '',
        videoUrl: '',
      }
      if (this.detailCourse) {
        if (payload.first) {
          const target = this.detailCourse.sections.flatMap(section => section.lessons).find(lesson => !lesson.isLocked && lesson.videoUrl)
          if (target) {
            lesson = target
          }
        } else {
          lesson = payload.selectedLesson
        }
      }
      console.log(lesson)
      this.nowVideo = lesson
    },
    menuChange(key) {
      this.menuActive = key
    },
  },
  async mounted() {
    try {
      const id = this.$route.params.id
      this.detailCourse = await this.$store.dispatch('course/FETCH_COURSE_BY_ID', { id })
      if (this.detailCourse) {
        if (this.carts.length) {
          this.isCarted = Boolean(this.carts.find(cart => cart.key === id))
        }
        this.PlayableVideo({ first: true, selectedLesson: [] })

        let otherCourse = []
        otherCourse = await this.$store.dispatch('course/FETCH_OTHER_VENDOR_COURSE_BY_ID', { id, vendorId: this.detailCourse.vendorId })

        if (otherCourse.length) {
          this.otherCourse = otherCourse.map(el => {
            return {
              ...el,
              key: el._id,
              title: el.name,
              type: el.type,
              price: el.price,
              instructor: el.vendor?.firstName + ' ' + el.vendor.lastName,
              rating: el.averageRating,
              reviews: el.countReviews,
            }
          })
        }
        this.isExistMyCourse = await this.$store.dispatch('course/FETCH_STATUS_EXIST_MYCOURSE', { id })
      }
    } catch (err) {
      console.log(err)
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading
    },
    sessionId() { return this.$store.state.user.sessionId },
    carts() { return this.$store.state.cart.carts },
  },
}
</script>

<style lang="scss">
.detail-course-container {
  // .video-container {
  //   // border-radius: 10px;
  //   // overflow: hidden;
  //   // height: 650px;

  //   // video {
  //   //   width: 100%;
  //   //   height: auto;
  //   // }
  // }

  .header {
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    @media (min-width: 768px) {
      & {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .subheading {
      display: inline-flex;
      gap: 12px;
      align-items: center;
    }

    .rating {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      p {
        opacity: 0.5;
      }
    }
  }

  section {
    margin-top: 30px;
  }

  .mentor-profile {
    display: inline-flex;
    gap: 12px;
    flex-direction: row;
    align-items: center;
  }

  .course-menu {
    margin-top: 20px;
    display: flex;
    gap: 12px;
  }

  .price-container {
    padding: 25px 16px 20px 16px;

    .group-flex {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .list-icon {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 8px;
        @media (min-width: 456px) {
          & {
            flex-direction: row;
            align-items: center;
          }
        }
      }
    }
  }

  .section {
    margin-top: 25px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    &-container {
      padding: 14px;
    }
  }
}
</style>
